import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	getConceptStatusValue,
	OncologyReviewConcept,
	ROncologyReviewItem,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { setFormModelOncologyReview } from "../../redux/formModelSlice"

export class OncologyReviewModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid])
		const modelsValue = valueForCid(OncologyReviewConcept.cid)
		if(!modelsValue) {
			return ok()
		}
		const rParseModels = z.array(ROncologyReviewItem).safeParse(modelsValue)
		if(!rParseModels.success) {
			return err(serializeFusionError('OncologyReviewModelReduxPersister parseModels', rParseModels.error))
		}
		dispatch(setFormModelOncologyReview(rParseModels.data))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState) {
		return prevState.formModel.oncologyReview !== nextState.formModel.oncologyReview
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: OncologyReviewConcept.cid,
			value: nextState.formModel.oncologyReview,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
